import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';

export class OnboardingWelcomeModalViewedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_WELCOME_MODAL_VIEWED;
  email?: string;
  redirected_from?: string;
  type?: string;
  billing_plan?: string;
  jurisdiction?: string;

  constructor(eventProperties: Partial<OnboardingWelcomeModalViewedEventTracking>) {
    super();
    this.email = eventProperties?.email;
    this.redirected_from = eventProperties?.redirected_from;
    this.type = eventProperties?.type;
    this.billing_plan = eventProperties?.billing_plan;
    this.jurisdiction = eventProperties?.jurisdiction;
  }
}
